/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import { injectIntl } from 'react-intl';
import {
  Grid,
  Col,
  Row,
  Form,
  FormGroup,
  FormControl,
  Button,
  Panel,
} from 'react-bootstrap';
import ActionButton from 'loracoms/ActionButton';
import ShowIf from 'loracoms/ShowIf';
import { applyAcctCode } from 'loraapi/Billing';
import CSSModules from 'react-css-modules';
import IntlMsg from 'lorautils/intl/IntlMsg';
import billingActions from 'loraactions/billing';
import orgActions from 'loraactions/org';
import PayStrategy from '../PayStrategy';
import styles from './styles/main.scss';
import imgSvcPkg from './images/svcpkg.svg';
import imgSvcPkgUser from './images/svcpkg-user.svg';
import imgUpgrade from './images/upgrade.svg';


const propTypes = {
  plan: React.PropTypes.object.isRequired,
  pushState: React.PropTypes.func.isRequired,
  intl: React.PropTypes.any.isRequired,
  getOrgBasic: React.PropTypes.func.isRequired,
  getPlan: React.PropTypes.func.isRequired,
};

class UnderCommercialView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      plan: props.plan,
      acctCode: '',
      acctCodeStatus: 'ready',
    };
    this.intlMsg = new IntlMsg(props.intl, 'billing.undercommercial');
    this.handleActivate = this.handleActivate.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { plan } = nextProps;
    if (plan !== this.props.plan) {
      this.setState({ plan });
    }
  }

  handleActivate(e) {
    e.preventDefault();

    const { getOrgBasic, getPlan } = this.props;

    const { acctCode } = this.state;
    if (acctCode.length > 0) {
      applyAcctCode(acctCode).then(() => {
        this.setState({ acctCodeStatus: 'success' });
        setTimeout(() => {
          getOrgBasic();
          getPlan();
        }, 1000);
      }).catch(() => {
        this.setState({ acctCodeStatus: 'failed' });
      });
    }
  }

  renderSvcPkg() {
    const { plan } = this.state;
    if (plan.tier === 1) {
      return this.renderSvcPkgUp();
    }
    return this.renderSvcPkgUser();
  }

  renderSvcPkgUp() {
    const header = (
      <span>
        <img src={imgSvcPkg} alt="" />
        {' '}
        {this.intlMsg.msg('acctcode.toactive.panelheader')}
      </span>
    );

    return (
      <div styleName="svc-pkg">
        <Panel bsStyle="aisz-white" header={header}>
          <div styleName="svc-pkg-desc">
            {this.intlMsg.msg('acctcode.toactive.desc1')} <br />
            <h3>{this.intlMsg.msg('acctcode.toactive.desc2')}</h3>
            <Button
              bsStyle="aisz-primary-ob"
              onClick={() => { window.location = '/public/prd/acct-code'; }}
            >
              {this.intlMsg.msg('acctcode.toactive.btn')}
              {' '}
              <i className="fa fa-arrow-circle-o-right" />
            </Button>
          </div>

          <div styleName="svc-pkg-form">
            <h3>{this.intlMsg.msg('acctcode.form.title')}</h3>
            <Form inline onSubmit={this.handleActivate}>
              <FormGroup>
                <FormControl
                  bsClass="aisz-form-control"
                  placeholder={this.intlMsg.msg('acctcode.form.placeholder')}
                  value={this.state.acctCode}
                  onChange={e => this.setState({ acctCode: e.target.value.trim() })}
                />
              </FormGroup>
              {' '}
              <FormGroup>
                <ActionButton
                  icon={<i className="fa fa-bolt" aria-hidden="true" />}
                  label={this.intlMsg.msg('acctcode.form.activate.btn')}
                  successLabel={this.intlMsg.msg('acctcode.form.activate.success')}
                  failedLabel={this.intlMsg.msg('acctcode.form.activate.failed')}
                  type="submit"
                  status={this.state.acctCodeStatus}
                  onStatusReset={() => this.setState({ acctCodeStatus: 'ready' })}
                />
              </FormGroup>
            </Form>
          </div>
        </Panel>
      </div>
    );
  }

  renderSvcPkgUser() {
    const { plan } = this.state;
    const header = (
      <span>
        <img src={imgSvcPkgUser} alt="" />
        {' '}
        {this.intlMsg.msg('acctcode.activated.panelheader')}
      </span>
    );
    let remainingStyle = '';
    let remainingTips = null;
    if (plan.remaining <= 30) {
      remainingStyle = 'remaining-urgent';
      remainingTips = <span styleName="remaining-tips">{this.intlMsg.msg('acctcode.activated.svcexpire.remain.tips')}</span>;
    }

    return (
      <div styleName="svc-pkg">
        <Panel bsStyle="aisz-white" header={header}>
          <div styleName="svc-pkg-desc">
            {this.intlMsg.msg('acctcode.activated.desc1')} <br />
            <ul className="list-unstyled">
              <li>
                <label> {this.intlMsg.msg('acctcode.activated.svcexpire.remain.lbl')} </label>{' '}
                <span styleName={remainingStyle}>{ plan.remaining }</span>{' '}
                <label> {this.intlMsg.msg('acctcode.activated.svcexpire.remain.unit')} </label>
              </li>
            </ul>
            { remainingTips }
          </div>
        </Panel>
      </div>
    );
  }

  renderCommUp() {
    const header = (
      <span>
        <img src={imgUpgrade} alt="" />
        {' '}
        {this.intlMsg.msg('commup.panelheader')}
      </span>
    );
    return (
      <div styleName="comm-up">
        <Panel bsStyle="aisz-white" header={header}>
          <div styleName="comm-up-desc">
            {this.intlMsg.msg('commup.desc1')}
            <div styleName="sub">
              {this.intlMsg.msg('commup.desc2')}
            </div>
          </div>
          <Button bsStyle="aisz-primary-o" onClick={() => this.props.pushState('/billing/recharge?amount=200')}>
            {this.intlMsg.msg('recharge.btn')}
            {' '}
            <i className="fa fa-level-up" aria-hidden="true" />
          </Button>
        </Panel>
      </div>
    );
  }

  renderPay() {
    const header = (
      <span>
        <img src={imgUpgrade} alt="" />
        {' '}
        {this.intlMsg.msg('pay.panelheader')}
      </span>
    );
    return (
      <div styleName="comm-up">
        <Panel bsStyle="aisz-white" header={header}>
          <div styleName="comm-up-desc">
            {this.intlMsg.msg('pay.title')}
          </div>
          <PayStrategy />
        </Panel>
      </div>
    );
  }

  render() {
    const { plan } = this.state;
    return (
      <div styleName="wrapper">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <ShowIf if={plan.tier === 1}>
                <div styleName="heading">
                  {this.intlMsg.msg('options.heading')}
                </div>
              </ShowIf>
            </Col>
          </Row>
          <Row>
            {this.renderCommUp()}
          </Row>
          <Row>
            {this.renderSvcPkg()}
          </Row>
          <Row>
            {this.renderPay()}
          </Row>
        </Grid>
      </div>
    );
  }
}


UnderCommercialView.propTypes = propTypes;

const mapStateToProps = state => ({
  plan: state.billing.plan.data || {},
});

const mapDispatchToProps = {
  pushState: routerActions.push,
  getPlan: billingActions.plan,
  getOrgBasic: orgActions.basic,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(CSSModules(UnderCommercialView, styles, { allowMultiple: true })));




// WEBPACK FOOTER //
// ./src/containers/Billing/coms/UnderCommercialView/index.jsx